import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ChatInterface from '../components/ChatInterface';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';

type ResearchLength = 'quick_scan' | 'targeted' | 'deep_dive';

interface ResearchPageProps {
  apiKey?: string;
  onApiKeyUpdate: (key: string) => void;
  isDarkMode: boolean;
  onToggleTheme: () => void;
}

const ResearchPage: React.FC<ResearchPageProps> = ({
  apiKey,
  onApiKeyUpdate,
  isDarkMode,
  onToggleTheme
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sidebarCollapsed } = useAppStore();
  
  // Get the data passed from homepage, research history, or template execution
  const { query, apiKey: passedApiKey, researchLength, sessionId, resumeSession, templateExecution } = location.state || {};
  
  // DEBUG: Log what we received from navigation
  console.log('🎯 ResearchPage DEBUG - Received props:', {
    query,
    passedApiKey: passedApiKey ? 'PROVIDED' : 'NOT_PROVIDED',
    researchLength,
    sessionId,
    resumeSession,
    templateExecution
  });

  // If no query was passed, redirect to homepage
  useEffect(() => {
    if (!query) {
      navigate('/home');
    }
  }, [query, navigate]);

  const handleBackToHome = () => {
    navigate('/home');
  };

  if (!query) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400 mb-4">No research query provided</p>
          <Button onClick={() => navigate('/home')} className="bg-gradient-to-r from-blue-600 to-sky-500 hover:from-blue-700 hover:to-sky-600">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
      </div>
    );
  }

  return (
    <ChatInterface 
      initialQuery={query}
      initialApiKey={passedApiKey || apiKey}
      researchLength={researchLength || 'targeted'}
      sessionId={sessionId}
      resumeSession={resumeSession}
      templateExecution={templateExecution}
      sidebarCollapsed={sidebarCollapsed}
    />
  );
};

export default ResearchPage;